import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Text, Touchable } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Bar from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/Header/Bar'
import { WorkedTimeData } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/lib/calculateWorkedTime'
import MinutesToText from 'modules/attendance/components/MinutesToText'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'

import WidgetHeader from '../WidgetHeader'

interface Props {
  workedTimeData: WorkedTimeData
  lineBorder: boolean
  range?: string
  employeeId: number
}

export const WorkedVsPlanned = ({ workedTimeData, lineBorder, range, employeeId }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const location = useLocation()
  const { pathParams } = useAttendanceDateNavigator()

  const { minutes, estimatedMinutes, dailyBalance } = workedTimeData

  const params = {
    ...pathParams,
    employeeId,
  }

  const workedHoursSidepanelUrl = location.pathname.includes(navigation.clockIn.path)
    ? navigation.clockIn.periodTypeYearMonthDay.workedHoursBreakdownEmployeeId.fullPath(params)
    : navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.workedHoursBreakdownEmployeeId.fullPath(
        params
      )

  return (
    <Touchable onClick={() => navigate(workedHoursSidepanelUrl)}>
      <Box
        justifyContent="center"
        paddingX="s24"
        border={{
          right: {
            color: lineBorder ? 'grey400' : 'grey000White',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        <Box inline justifyContent="flexStart" minWidth="s240" width="full">
          <Box gap="s16">
            <WidgetHeader
              title={i18n.t('clock_in.worked_vs_planned_header.worked_hours')}
              range={range}
            />
            <Box gap="s8">
              <Bar estimatedMinutes={estimatedMinutes} minutes={minutes} showMemo />
              <Box flexDirection="row" justifyContent="spaceBetween" gap="s16">
                <Box flexDirection="row" gap="s4" alignItems="baseline">
                  <MinutesToText color="grey1000" value={minutes} size="400" weight="medium" />
                  <Text color="grey800" size="100" weight="normal">
                    /
                  </Text>
                  <MinutesToText
                    color="grey800"
                    value={estimatedMinutes}
                    size="100"
                    weight="normal"
                  />
                  <Text color="grey800" size="100" weight="normal">
                    {i18n.t('clock_in.worked_vs_planned_header.planned').toLowerCase()}
                  </Text>
                </Box>
                <MinutesToText
                  color="grey700"
                  value={dailyBalance}
                  size="400"
                  weight="medium"
                  withPlusSign
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Touchable>
  )
}
